<div class="notifications" role="alert" [ngStyle]="notificationStyle">
    <div class="container">
        <app-notification
            *ngFor="let notification of notifications"
            [data]="notification"
            (closeNotification)="removeNotification(notification)"
            [initiateClose]="notification.initiateClose"
        ></app-notification>
    </div>
</div>
